import React, { useMemo } from "react";

/** Lista kiemelés — AI címkék futószalag a kártya képe alján (csak szöveg, háttér nélkül). */
export function AiLabelsMarquee({ labels = [], carId }) {
  const items = useMemo(() => labels.filter(Boolean), [labels]);

  const copies = useMemo(() => {
    if (!items.length) return 0;
    const n = items.length;
    let c = Math.max(4, Math.ceil(12 / n) * 2);
    if (c % 2 !== 0) c += 1;
    return c;
  }, [items.length, items]);

  const sequence = useMemo(
    () => (items.length ? Array.from({ length: copies }, () => items).flat() : []),
    [items, copies],
  );

  if (!items.length) return null;

  return (
    <div
      data-testid={`ai-labels-marquee-${carId}`}
      className="ai-labels-marquee-root inline-flex max-w-[min(280px,calc(100%-0.25rem))] min-w-0 py-0.5"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="ai-labels-marquee-mask flex-1 min-w-0">
        <div className="ai-labels-marquee-row flex w-max flex-nowrap items-center gap-5">
          {sequence.map((label, i) => (
            <span
              key={`${label}-${i}`}
              className="text-[10px] font-bold tracking-wide uppercase whitespace-nowrap"
            >
              {label}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
